export default __webpack_public_path__ + "static/media/welcome-background.caeb6035.png";